import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, from, lastValueFrom } from 'rxjs';
import { TenantService } from '../tenant/tenant.service';
import { SKIP_INTERCEPTOR } from 'src/constants';

@Injectable()
export class ApiIntecerceptorService implements HttpInterceptor {

  constructor(private tenantService: TenantService) { }

  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.headers.has(SKIP_INTERCEPTOR)) {
      const apiRequest = req.clone({ headers: req.headers.delete(SKIP_INTERCEPTOR) });
      return next.handle(apiRequest);
    }
    return from(this.handle(req, next));
  }

  private async handle(req: HttpRequest<unknown>, next: HttpHandler): Promise<HttpEvent<unknown>> {
    const authHeaders = await this.tenantService.getAuthorizationHeaders();
    const existingHeaders = req.headers;
    let combinedHeaders = new HttpHeaders();
    authHeaders.keys().forEach(key => combinedHeaders = combinedHeaders.set(key, authHeaders.get(key) ?? ''));
    existingHeaders.keys().forEach(key => combinedHeaders = combinedHeaders.set(key, existingHeaders.get(key) ?? ''));

    const baseUrl = await this.tenantService.getApiUrl();
    const apiRequest = req.clone({ url: `${baseUrl}${req.url}`, headers: combinedHeaders });
    return lastValueFrom(next.handle(apiRequest));
  }
}